app.component("dalk", {
	templateUrl: "app/src/js/components/operationNote/eyeBank/dalk/dalk.html",
	controller: "dalkController",
	bindings: {
		data: "<",
		eyeTitle: "@",
		procedure: "=",
	},
});

app.controller("dalkController", [
	"$scope",
	function ($scope) {
		this.$onInit = function () {
			$scope.isVisible = false;
		};

		$scope.$watch(
			"$ctrl.procedure",
			function (newValue, oldValue) {
				if (newValue && newValue.concept_id === "771988004") {
					$scope.isVisible = true;
					$scope.$ctrl.data.dalk_section = {
						surgical_goals: {
							is_pain_relief: false,
							is_improved_visual_acuity: false,
							is_tectonic_structural_repair: false,
							is_cosmesis: false,
						},
						pre_op_history: {},
						recipient_cornea: {},
						corneal_suture: {},
						ovd: [],
						graft_history: {
							previous_graph_count: {},
							previous_graft_failure_reason: {
								is_primary_non_function: false,
								is_detachment: false,
								is_rejection: false,
								is_endothelial_failure: false,
								other: false,
							},
						},
					};
				} else {
					$scope.isVisible = false;
					// The primary procedure moved off this graft type: drop its form, or it is saved
					// alongside the new one. Not on the first run, which only reflects loaded data.
					if (newValue !== oldValue && $scope.$ctrl.data?.dalk_section) {
						$scope.$ctrl.data.dalk_section = undefined;
					}
				}
			},
			true
		);

		$scope.$on("$destroy", () => {
			$scope.isVisible = false;
			if ($scope.$ctrl.data?.dalk_section) {
				$scope.$ctrl.data.dalk_section = undefined;
			}
		});
	},
]);
